export const URLS = {
	LOGIN: '/login',
	MAIN: '/',
	TARGETS_ITEM: '/targets/:targetId',
	MENU: '/menu',
	CATALOG: '/catalog',
	GRAPHS: '/graphs',
	SETTINGS: '/settings',
};
